var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import T, { addTranslations } from '../../Utils/Locale';
import { getGlobalState } from '../../Utils/GlobalState';
import Modal from '../../Components/ComponentModal';
import SelectProducts from './SelectProducts';
import SelectDateTime from './SelectDateTime';
import SelectPartners from './SelectPartners';
import ConfirmPurchase from './ConfirmPurchase';
import AuthenticationCreateForm from '../Authentication/AuthenticationCreateForm';
import AuthenticationLoginForm from '../Authentication/AuthenticationLoginForm';
import InputPhone from './InputPhone';
import PurchaseType from './PurchaseType';
import useEndpoint from '../../Hooks/UseEndpoint';
import { addToBasket, addMultipleToBasket, fetchUser } from './API';
import translations from './translations.yml';
import isUserAuthenticated from '../../Utils/IsUserAuthenticated';
addTranslations(translations);
const PAGES = {
    PRODUCTS: 0,
    PARTNERS: 1,
    LOGIN: 2,
    CREATE_USER: 3,
    DATE: 4,
    CONFIRM: 5,
    PHONE: 6
};
const PurchaseModal = ({ closeModal, selectedProduct, purchaseType = PurchaseType.ADVICE, partner = null }) => {
    var _a;
    const [user, setUser] = useState({});
    const [isUserLoading, setUserLoading] = useState(true);
    const [pages, setPages] = useState();
    const [isPartnersLoading, setPartnersLoading] = useState(true);
    const [availablePartners, setAvailablePartners] = useState([]);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isGoBackButtonVisible, setGoBackButtonVisible] = useState(true);
    /**
     * If the default product are a machine name, update it to the corresponding object.
     */
    useEndpoint('/api/get-all-products', (fetchedProducts) => {
        if (typeof selectedProduct === 'string') {
            const selectedProductAsObject = fetchedProducts.find((fetchedProduct) => fetchedProduct.machineName === selectedProduct);
            setSelectedProducts([selectedProductAsObject]);
        }
    }, 'products');
    useEffect(() => {
        fetchUserDetails();
        fetchPartners();
    }, []);
    useEffect(() => {
        function setInitState() {
            return __awaiter(this, void 0, void 0, function* () {
                if (isUserLoading || isPartnersLoading) {
                    return;
                }
                if (isUserAuthenticated(user)) {
                    setSelectedPartners(user.partners);
                }
                if (partner != null && availablePartners != null) {
                    setSelectedPartners([availablePartners.find(partnerItem => partnerItem.id === partner)]);
                }
                let startPage = [PAGES.PRODUCTS];
                if (selectedProduct) {
                    startPage = partner == null ? [PAGES.PARTNERS] : [PAGES.CONFIRM];
                    setGoBackButtonVisible(false);
                    if (isUserAuthenticated(user)) {
                        if (purchaseType === PurchaseType.ADVICE) {
                            startPage = [PAGES.DATE];
                        }
                        else {
                            const applicationUrl = getGlobalState('application_url');
                            yield addToBasket(selectedProduct, purchaseType);
                            window.location.href = `${applicationUrl}/opret-dokument/${selectedProduct}`;
                            return;
                        }
                    }
                }
                setPages(startPage);
            });
        }
        setInitState();
    }, [isUserLoading, user, availablePartners, isPartnersLoading, partner]);
    /**
     * Append a page to the pages array, making it the current page.
     *
     * @param {int} page
     */
    const goToPage = (page) => {
        const newPages = pages.slice();
        newPages.push(page);
        setPages(newPages);
    };
    /**
     * Remove the latest item from the pages array, going one page back.
     */
    const goToPreviousPage = () => {
        setPages(pages.slice(0, -1));
    };
    /**
     * Check if a page is the latest in the pages array.
     *
     * @param {int} page
     *
     * @returns {boolean}
     */
    const isCurrentPage = (page) => {
        if (!pages) {
            return false;
        }
        return pages[pages.length - 1] === page;
    };
    /**
     * Redirect the user to quickpay to pay for the digital document.
     */
    function startPaymentDigital() {
        return __awaiter(this, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            yield addToBasket(selectedProducts[0].machineName, purchaseType);
            window.location.href = `${applicationUrl}/basket`;
        });
    }
    /**
     * Confirm the booking and redirect the user to the payment URL.
     */
    function startPaymentBooking(bookingStartTime) {
        return __awaiter(this, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            const productsToAdd = selectedProducts.map((product) => product.machineName);
            yield addMultipleToBasket(productsToAdd, PurchaseType.ADVICE);
            window.location.href = `${applicationUrl}/basket?employee=${encodeURIComponent(bookingStartTime.resources[0].id)}&date=${encodeURIComponent(bookingStartTime.start)}`;
        });
    }
    function saveUserPartners() {
        return __awaiter(this, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            const partners = selectedPartners.map((partner) => partner.selectedFromList || partner.id);
            yield axios.post(`${applicationUrl}/api/user/save-partners`, { partners }, { withCredentials: true });
        });
    }
    function onSelectProductsFinish(selectedProductsUpdated) {
        setSelectedProducts(selectedProductsUpdated);
        if (!selectedPartners.length) {
            goToPage(PAGES.PARTNERS);
        }
        else {
            goToPage(PAGES.CONFIRM);
        }
    }
    function onSelectDateTimeFinish(startTime) {
        if (startTime == null) {
            return;
        }
        if (purchaseType === PurchaseType.ADVICE) {
            startPaymentBooking(startTime);
        }
        else {
            startPaymentDigital();
        }
    }
    function onSelectPartnersFinish(theSelectedPartners) {
        setSelectedPartners(theSelectedPartners);
        goToPage(PAGES.CONFIRM);
    }
    function finished() {
        return __awaiter(this, void 0, void 0, function* () {
            yield saveUserPartners();
            if (purchaseType === PurchaseType.ADVICE) {
                goToPage(PAGES.DATE);
            }
            else {
                yield addToBasket(selectedProduct, purchaseType);
                const applicationUrl = getGlobalState('application_url');
                window.location.href = `${applicationUrl}/opret-dokument/${selectedProduct}`;
            }
        });
    }
    function onConfirmBookingFinish(createUser = false, login = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (createUser) {
                goToPage(PAGES.CREATE_USER);
            }
            else if (login) {
                goToPage(PAGES.LOGIN);
            }
            else {
                yield finished();
            }
        });
    }
    const goBackButtonElement = (_jsxs("div", Object.assign({ className: 'flex flex-row pb-5 items-center' }, { children: [_jsx("svg", Object.assign({ width: '22', height: '22', fill: 'none', y: '82', className: 'transform -rotate-180' }, { children: _jsx("path", { d: 'M9.232 16.232a2.5 2.5 0 003.536 3.536l-3.536-3.536zM18 11l1.768 1.768a2.5 2.5 0 000-3.536L18 11zm-5.232-8.768a2.5 2.5 0 10-3.536 3.536l3.536-3.536zm0 17.536l7-7-3.536-3.536-7 7 3.536 3.536zm7-10.536l-7-7-3.536 3.536 7 7 3.536-3.536z', fill: '#004f54' }) })), _jsx("button", Object.assign({ type: 'button', title: T('bookMeeting.back'), onClick: goToPreviousPage, className: 'tailwind-reset transparent text-dark-teal' }, { children: T('bookMeeting.back') }))] })));
    return (_jsx(Modal, Object.assign({ closeModal: closeModal, className: 'meeting-modal' }, { children: _jsxs("div", Object.assign({ className: 'book-meeting-modal relative font-viva' }, { children: [isCurrentPage(PAGES.PRODUCTS) && (_jsx(SelectProducts, { onFinish: (selectedProductsUpdated) => onSelectProductsFinish(selectedProductsUpdated), selectedProducts: selectedProducts, purchaseType: purchaseType })), isCurrentPage(PAGES.PARTNERS) && (_jsx(SelectPartners, { onFinish: (partnersSelected) => onSelectPartnersFinish(partnersSelected), onBack: goToPreviousPage, theSelectedPartners: selectedPartners, isGoBackButtonVisible: isGoBackButtonVisible, partners: availablePartners })), isCurrentPage(PAGES.DATE) && (_jsx(SelectDateTime, { onFinish: onSelectDateTimeFinish, selectedProductsName: selectedProducts.map(product => product.machineName).join(',') })), isCurrentPage(PAGES.CONFIRM) && (_jsx(ConfirmPurchase, { selectedPartners: selectedPartners, selectedProducts: selectedProducts, onFinish: onConfirmBookingFinish, user: user, onBack: goToPreviousPage, purchaseType: purchaseType })), isCurrentPage(PAGES.LOGIN) && (_jsxs("div", Object.assign({ className: 'bg-white' }, { children: [_jsx("div", Object.assign({ className: 'bg-dark-teal py-2' }, { children: _jsx("h2", Object.assign({ className: 'tailwind-reset title text-xl px-3 pt-5 md:pt-0 md:text-3xl text-center text-white' }, { children: T('authentication.authenticate.title') })) })), _jsxs("div", Object.assign({ className: 'p-8 md:mx-12' }, { children: [_jsx(AuthenticationLoginForm, { onFinish: finished }), goBackButtonElement] }))] }))), isCurrentPage(PAGES.CREATE_USER) && (_jsxs("div", Object.assign({ className: 'bg-white' }, { children: [_jsx("div", Object.assign({ className: 'bg-dark-teal py-2' }, { children: _jsx("h2", Object.assign({ className: 'tailwind-reset title text-xl px-3 pt-5 md:pt-0 md:text-3xl text-center text-white' }, { children: T('authentication.create.button') })) })), _jsxs("div", Object.assign({ className: 'p-8 md:mx-12' }, { children: [_jsx(AuthenticationCreateForm, { phoneRequired: true, onFinish: finished, showPartnerConsents: true, partner: (_a = selectedPartners === null || selectedPartners === void 0 ? void 0 : selectedPartners[0]) === null || _a === void 0 ? void 0 : _a.id }), goBackButtonElement] }))] }))), isCurrentPage(PAGES.PHONE) && (_jsx(InputPhone, { back: goToPreviousPage, next: finished }))] })) })));
    function fetchUserDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetchUser();
                setUser(response);
            }
            finally {
                setUserLoading(false);
            }
        });
    }
    function fetchPartners() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const applicationUrl = getGlobalState('application_url');
                const response = yield axios.get(`${applicationUrl}/api/partners?priority=1`, { withCredentials: true });
                setAvailablePartners(response.data);
            }
            catch (error) {
                throw error;
            }
            finally {
                setPartnersLoading(false);
            }
        });
    }
};
export default PurchaseModal;
